// Le compte du joueur : ce qui le concerne lui, et non son matériel ni son jeu.

import { api } from './api.ts';

// ── L'index du joueur ───────────────────────────────────────────────────────

export interface HandicapEntry {
    id: string;
    /** Negatif pour un index « plus », meilleur que le scratch. */
    indexValue: number;
    recordedAt: string;
}

export interface HandicapState {
    current: HandicapEntry | null;
    /** Du plus recent au plus ancien, soixante saisies au maximum. */
    history: HandicapEntry[];
}

export const getHandicap = () => api<HandicapState>('/me/handicap');

export const addHandicap = (indexValue: number) =>
    api<HandicapEntry>('/me/handicap', { method: 'POST', body: { indexValue } });

export const deleteHandicap = (id: string) =>
    api<void>(`/me/handicap/${id}`, { method: 'DELETE' });

/** L'index tel qu'on l'ecrit au golf.
 *
 *  Un index meilleur que le scratch se note « +2,1 » et non « -2,1 » : au
 *  golf, le signe plus signale un joueur qui REND des coups. C'est
 *  contre-intuitif hors du terrain, et l'inverser serait un contresens pour
 *  quiconque connait le jeu. La virgule est decimale, comme partout en France.
 */
export function formatHandicap(v: number | null | undefined): string {
    if (v == null) return '\u2014';
    const s = Math.abs(v).toFixed(1).replace('.', ',');
    return v < 0 ? `+${s}` : s;
}

/** L'index d'un joueur qui n'a rien saisi.
 *
 *  54,0 est le plafond du World Handicap System et le point d'entree de la
 *  federation : un debutant licencie demarre la, puis descend. C'est donc la
 *  valeur juste par defaut, et non « inconnu ».
 *
 *  Elle n'est PAS ecrite dans l'historique. Une ligne a 54 le jour de
 *  l'inscription fabriquerait une progression qui n'a pas eu lieu : un joueur
 *  qui arrive et saisit 15,2 afficherait « -38,8 depuis votre premiere
 *  saisie ». Le defaut vit a l'affichage, l'historique ne contient que ce que
 *  le joueur a reellement saisi.
 */
export const INDEX_DEFAUT = 54;
